import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie';
import axios from 'axios';
import {useNavigate, useSearchParams } from 'react-router-dom'
import ChatCard from './ChatCard';
import ChatRightMe from './ChatRightMe';
import ChatLeftUser from './ChatLeftUser';
import MyProfileSidebar from './MyProfileSidebar';
import GroupChatbar from './GroupChatbar';
import UserProfilebar from './UserProfilebar';
import SearchMessages from './SearchMessages';
import io from "socket.io-client";
import { useRef } from 'react';
import GroupChatCard from './GroupChatCard';
import VideoCall from './VideoCall';
import{Link} from "react-router-dom";

 
const cookies = new Cookies();
var socket = io("https://newchatapp-mn65.onrender.com");

function HomePage({ date }) {
    document.body.style.backgroundColor = "#111b21";
    
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [user, setUser] = useState({})
    const [input, setInput] = useState("")
    const [tokenToSend, setTokenToSend] = useState("");
    const [userCards, setUserCards] = useState([])
    const [currMessages, setCurrMessages] = useState([])
    const [lstMessage, setlstMessage] = useState("");
    const bottomRef = useRef(null);
    const drpDown = useRef();
    const [search, setSearch] = useState("");
    const [rightDisplay, setRightDisplay] = useState({
        image:"",
        firstname:"",
        email:"",
        room:"",
        showRight:false,
        groupId:""
    })
    

    useEffect(() => {
      if(lstMessage!==""){
        setUserCards(prev=>{
            prev.forEach((ele)=>{
                if(rightDisplay.groupId){
                    if (ele._id===rightDisplay.groupId){
                        ele.lstMessage=lstMessage;
                    }
                }else{
                    if (ele.email===rightDisplay.email){
                        ele.lstMessage=lstMessage;
                    }
                }
            })
            return [...prev]
        })
      }
    }, [lstMessage])
    

    useEffect(() => {
        if (token) {
            setTokenToSend(token);
            cookies.set('token', token, { path: '/', expires: date, sameSite: true })
            axios.get("https://newchatapp-mn65.onrender.com/test", {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((res) => {
                setUser(res.data);
                // console.log(res.data);
            })
            axios.get("https://newchatapp-mn65.onrender.com/users", {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }).then((res)=>{
            setUserCards(res.data);
        })
        } else {
            const cookie = cookies.get('token');
            if (!cookie) navigate("../unauthorize", { replace: true });
            if (cookie) cookies.set('token', cookie, { path: '/', expires: date, sameSite: true })
            setTokenToSend(cookie);
            axios.get("https://newchatapp-mn65.onrender.com/test", {
                headers: {
                    Authorization: 'Bearer ' + cookie
                }
            }).then((res) => {
                setUser(res.data);
            })
            axios.get("https://newchatapp-mn65.onrender.com/users", {
            headers: {
                Authorization: 'Bearer ' + cookie
            }
        }).then((res)=>{
            setUserCards(res.data);
            // console.log(res.data);
        })
        }
        

    }, [])

 
    

    useEffect(() => {
          
      socket.on("recieve_message",(data)=>{
        // console.log(data);
        if(data.group){

        }else{
            userCards.forEach(ele=>{
                if(ele.email===rightDisplay.email){
                    ele.lstMessage=data.body;
                }
            })
        }
       
            setCurrMessages((prev)=>{
                if(data.group){
                    setlstMessage(data.body);
                    return(
                        [{body:data.body,time:data.time,sender:data.sender,group:data.group},...prev]
                    )
                }else{
                    
                   setlstMessage(data.body);

                    return(
                        [{body:data.body,time:data.time,sender:data.sender},...prev]
                    )
                }
                
            })
        
      })
  
    }, [socket])
    
    useEffect(() => {
        
        bottomRef.current && bottomRef.current.scrollIntoView({behavior: 'smooth'});
        
      }, [currMessages]);

     
      
      function removeDrop(e){
        if(!e.target.classList.value.includes("dontInclude")){
            // const doc = document.querySelector(".dropdown-content-home");
            // doc.classList.remove("show-drpdown");
            // OR
            drpDown.current.classList.remove("show-drpdown");
            
        }
        
      }

    function homeDprDwn() {
        // const doc = document.querySelector(".dropdown-content-home");
        drpDown.current.classList.toggle("show-drpdown");
    }

    function handleMyProfile() {
        document.querySelector(".myProfile").classList.add("translateProfile");
    }
    function handleGroupChat() {
        document.querySelector(".groupChatBar").classList.add("translateProfile");
    }
    function handleUserProfile() {
        document.querySelector(".userProfilebar").classList.add("translateLeft");
    }

    function handleSearchMessage() {
        document.querySelector(".Searchmessages").classList.add("translateLeft");
    }

    function getMyImg(img) {
        var imgtag = document.getElementById("myimg");
            imgtag.src = img;
    }
   
    const sendMessage = ()=>{
        if(input==="") return;

        var time = new Date();

        var t = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

        const yyyy = time.getFullYear();
        let mm = time.getMonth() + 1; 
        let dd = time.getDate();
        
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        
        const formattedDate = dd + '/' + mm + '/' + yyyy;

       if(rightDisplay.groupId){
        userCards.forEach(element => {
            if(element._id===rightDisplay.groupId){
                element.lstMessage=input;
            }
        })
        socket.emit("send_group_message",{body:input,time:t,me:user.firstname,roomId:rightDisplay.room,groupId:rightDisplay.groupId,date:formattedDate})
       }else{
        userCards.forEach(element => {
            if(element.email===rightDisplay.email){
                element.lstMessage=input;
            }
        })
        socket.emit("send_message",{body:input,time:t,me:user.firstname,sender:rightDisplay.firstname,senderMail:user.email,receiverMail:rightDisplay.email,roomId:rightDisplay.room,date:formattedDate})
       }

        setCurrMessages((prev)=>{
            return(
                [{body:input,time:t},...prev]
            )
        })
        setInput("");
    }

    function handleLogout(){
        axios.get("https://newchatapp-mn65.onrender.com/logout").then((res)=>{
            // console.log(res.data);
            cookies.remove("token");
            navigate("../login", { replace: true });
        })
                
    }
 
    

    function chatCards(singleCard){
        
         if(singleCard.firstname.toLowerCase().includes(search.toLowerCase())||search==""){
            if(singleCard.users){
                return(
                    <GroupChatCard me={user.firstname} lstMessage={singleCard.lstMessage} setCurrMessages={setCurrMessages} socket={socket} token={tokenToSend} id={singleCard._id} firstname={singleCard.firstname} image={singleCard.image}  setRightDisplay={setRightDisplay} users={singleCard.users} roomId={singleCard.roomId} />
                )
        }else{
            return(
                <ChatCard  lstMessage={singleCard.lstMessage} setCurrMessages={setCurrMessages} socket={socket} token={tokenToSend} messages={user.messages} firstname={singleCard.firstname} image={singleCard.image} email={singleCard.email} setRightDisplay={setRightDisplay} reciever={rightDisplay.reciever}  />
            )
        }
        }
        
    }



    return (
        <div  onClick={removeDrop} style={{ display: "grid", gridTemplateColumns: "4.2fr 7.8fr" }} className='home'>
            <div style={{ flex: "4" }} className="homeleft">
                <section  style={{userSelect:"none"}} className='homesection'>
                    <img  draggable="false" id='myimg' onClick={handleMyProfile} className='homeprofilepic' src={user.image} alt="" />
                    <MyProfileSidebar token={tokenToSend} getMyImg={getMyImg} firstname={user.firstname} lastname={user.lastname} image={user.image} />
                    <GroupChatbar mymail={user.email} userCards={userCards}  />
                    <ul className='homenavul'>
                        <div onClick={handleGroupChat}><li><i style={{ color: "white" }} class="fa-lg fa-solid fa-people-group"></i></li></div>

                        <div ><li><div className="drp-dwn">
                            <i onClick={homeDprDwn} style={{ color: "white",padding: "8px" }} className="fa-lg fa-solid fa-ellipsis-vertical dontInclude"></i>
                            <div ref={drpDown} class="dropdown-content-home ">
                            <Link className='chartLink' to={"/charts"}><div className="homedropdown1">Charts</div></Link>
                                <div onClick={handleLogout} className="homedropdown2">Logout</div>
                            </div>
                        </div></li></div>
                    </ul>
                </section>
                <div  className="innerleft">
                    <input onChange={(e)=>{setSearch(e.target.value)}} value={search} className='homenavinput' type="search" name="" id="search_input" placeholder='Search User' />
                    <div style={{userSelect:"none"}} className="chats">
                        {userCards.map(chatCards)}
                    </div>
                </div>
            </div>
            {rightDisplay.showRight?
                <div style={{ display: "flex" }}  className="right">
                <div style={{ flex: "8", backgroundColor: "#111b21" }} className="homemid">
                    <section style={{userSelect:"none"}} className='homesection navForRight'>
                        <div onClick={handleUserProfile} className="openusernav">
                            <img draggable="false" className='homeprofilepic' src={rightDisplay.image ? rightDisplay.image:"images/defaultProfile.png"} alt="" />
                            <div className="openusernavdetail">
                                <h3 id='rightnavh3'>{rightDisplay.firstname && rightDisplay.firstname }</h3>
                                <p id='rightnavp'>click here to see contact info</p>
                            </div>
                        </div>
                        <ul className='homenavul homenavright'>
                            {/* <div onClick={handleSearchMessage}><li><i style={{ color: "white" }} class="fa-solid fa-magnifying-glass"></i></li></div> */}
                            {!rightDisplay.groupId && <VideoCall me={user.firstname} opposeUser={rightDisplay.firstname} socket={socket} token={tokenToSend} roomId={rightDisplay.room} />}
                        </ul>
                    </section>
                    <div id='messages' className="messages">
                    <span  ref={bottomRef}></span>
                        {currMessages?currMessages.map((message)=>{
                            if(message.group){
                                if(message.sender===user.firstname){
                                    return <ChatRightMe body={message.body} time={message.time}  /> 
                                }else{
                                    return <ChatLeftUser body={message.body} time={message.time} sender={message.sender} />
                                }
                            }else{
                                if(message.sender){
                                return <ChatLeftUser body={message.body} time={message.time} />
                                }else{
                                    return <ChatRightMe body={message.body} time={message.time}  /> 
                                }
                            }
                        }):setRightDisplay({})}
                        
                    </div>
                    <div className="chattypediv">
                        <input suppressContentEditableWarning={true} onKeyDown={(e)=>{if(e.keyCode===13){sendMessage()}}} autoFocus  onChange={(e)=>{setInput(e.target.value)}} value={input} className='chatTypeInput' type="text" name="" id="type" />
                        <i onClick={sendMessage} style={{ cursor: "pointer" }} className=" sendmessage fa-regular fa-paper-plane"></i>
                    </div>
                </div>
                <UserProfilebar groupId={rightDisplay.groupId && rightDisplay.groupId} image={rightDisplay.image} firstname={rightDisplay.firstname} />
                <SearchMessages />
            </div>:
            <div  style={{height:"100vh",display:"flex",justifyContent:"center",alignItems:"center"}} className="refreshadstate">
                <h1 style={{color:"#008069",fontSize:"5rem",fontWeight:"800",userSelect: "none"}}>ChatApp</h1>
            </div>
            }
        </div>
    )
}

export default HomePage